<template>
    <div>
        <table-tool-bar>
            <template slot="left">
                <table-searcher
                    v-model="filter.orderNo"
                    placeholder="请输入订单编号"
                    style="margin-left: 10px;"
                    @search="search"
                ></table-searcher>
            </template>
        </table-tool-bar>
        <Table ref="mt" :columns="columns" :data="page.list" :loading="loading" :height="mtHeight">
            <!-- 操作列 -->
            <template v-slot:action="{ row }"></template>
        </Table>
        <!-- 底部分页 -->
        <table-pager
            placement="top"
            :total.sync="page.total"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.pageNo"
            @change="fetch"
        ></table-pager>
    </div>
</template>
<script>
import { mapCell, pipeCell } from "_c/grid/renderCell";
import { sRewardDeatilList } from "@/api/sell";
import Dict from "_u/dict";

const PAGE_SIZE = 20;

export default {
    name: "s-reward-detail-list",
    props: {
        wxUserId: {
            type: [String, Number],
            default: "",
        },
    },
    components: {},

    data() {
        return {
            mtHeight: 390,
            loading: false,
            filter: {
                pageNo: 1,
                pageSize: PAGE_SIZE,
                orderNo: "",
            },
            page: {
                total: 0,
                list: [],
            },
            dict: {
                captainLevel: Dict.NULL,
            },
        };
    },

    computed: {
        columns() {
            return [
                {
                    type: "index",
                    title: "序号",
                    align: "center",
                    width: 60,
                },
                {
                    key: "orderNo",
                    title: "订单号",
                    align: "left",
                    minWidth: 210,
                    tooltip: true,
                },
                {
                    key: "payAmount",
                    title: "实付金额",
                    align: "right",
                    minWidth: 100,
                    render: pipeCell("currency"),
                },
                {
                    key: "amount",
                    title: "获得佣金",
                    align: "right",
                    minWidth: 100,
                    render: pipeCell("currency"),
                },
                {
                    key: "commissionRatio",
                    title: "分佣比例",
                    align: "right",
                    minWidth: 100,
                },
                {
                    key: "leaderGrade",
                    title: "等级",
                    align: "center",
                    minWidth: 60,
                    render: mapCell(this.dict.captainLevel.toList()),
                },
                {
                    key: "souceUserName",
                    title: "佣金来源",
                    align: "left",
                    minWidth: 120,
                    tooltip: true,
                },
                {
                    key: "payTime",
                    title: "订单完成时间",
                    align: "center",
                    minWidth: 160,
                    render: pipeCell("ymdL"),
                },
            ];
        },
    },

    watch: {},

    created() {
        this.fetch();
    },

    mounted() {
    },

    methods: {
        fetch() {
            this.loading = true;

            const filter = Object.assign(this.filter, {
                wxUserId: this.wxUserId,
            });

            Promise.all([Dict.get(["captain_level"]), sRewardDeatilList(filter)])
                .then((args) => {
                    var [dictGroup, page] = args;

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name];
                    });

                    page.data.page.list.forEach(item => {
                        item.payAmount /= 100
                        item.amount /= 100
                        item.commissionRatio = (item.commissionRatio*100).toFixed(2)+"%"
                    })

                    this.setPageData(page.data);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        search() {
            this.filter.pageNo = 1;
            this.fetch();
        },

        setPageData(data) {
            this.page.list = data.page.list;
            this.page.total = parseInt(data.page.totalCount);
        },
    },
};
</script>
<style lang="less" scoped></style>
